module.exports = "https://p.cds.unp.clasificados.pe/logo-visa.2d164375d0d411dbedaea2398d5b4b7c.svg";